var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"disable-dbl-tap-zoom",staticStyle:{"background-color":"#f5f5f5"},attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }